export default __webpack_public_path__ + "static/media/desk5.f303f092.png";